/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_NoteInputs */

const de__field_note = /** @type {(inputs: _Field_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notiz`)
};

/**

* @param {_Field_NoteInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_note = /** @type {((inputs?: _Field_NoteInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_NoteInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_note(inputs)
});